import React, { useState ,
  useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Table,
  Input,
  Collapse,
  Card,
  Form,
  FormGroup,
  Label,
  CardBody
} from "reactstrap";
import toastr from "toastr"
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import  { useHistory } from  'react-router-dom'
//Import Images
import img1 from "../../assets/images/product/img-1.png";
import img6 from "../../assets/images/product/img-6.png";
import  Spinner  from 'react-spinkit'
import Backdrop from '@material-ui/core/Backdrop';
import '../../NumberInput.css'
import axios from "../../axios"
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles';
import Select from "react-select";
import numeral from "numeral";
const orderSummary = [
  {
    id: 1,
    img: img1,
    productTitle: "Nike N012 Running Shoes",
    price: 260,
    qty: 2,
  },
  { id: 2, img: img6, productTitle: "Adidas Running Shoes", price: 260, qty: 1 },
];
const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }));
const EcommerceCheckout = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [Purchasesavess, setPurchasesavess] = useState(false)
  const [dailoa1, setdailoa1] = useState(false)
  const toggle = () => setIsOpen(!isOpen);
  const history = useHistory()
  const [isOpenShippinginfo, setIsOpenShippinginfo] = useState(false);

  const toggleShippinginfo = () => setIsOpenShippinginfo(!isOpenShippinginfo);
  const [allcartproducts, setallcartproducts] = useState([])
  const [isOpenPaymentinfo, setIsOpenPaymentinfo] = useState(false);
  const classes = useStyles();
  const [tokent, settokent] = useState('Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ')
  const [purchseid, setpurchseid] = useState('')
  const togglePaymentinfo = () => setIsOpenPaymentinfo(!isOpenPaymentinfo);
  const [allsupplierinfo, setallsupplierinfo] = useState([])
  const [suppliid, setsuppliid] = useState('')
  const [onsupplierinfo, setonsupplierinfo] = useState([])
  const [emailid, setemailid] = useState('')
  const [phone, setphone] = useState('')
  const [city, setcity] = useState('')
  const [zipcode, setzipcode] = useState('')

  const [deliverydate, setdeliverydate] = useState(new Date())
  const [country, setcountry] = useState('')
  const [address, setaddress] = useState('')
  const [supperror, setsupperror] = useState(false)
  var imageDefault = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAANlBMVEX///+/v7+8vLzKysr8/Pzg4ODFxcXb29vT09Pj4+P4+PjBwcH6+vry8vLY2NjIyMjs7Ozo6Oia8u11AAAEdUlEQVR4nO2d65bqIAxGp/Smrb34/i971KqlEC7FGuJZ3/7dKewJBgK4/PsDAAAAAAAAAAAAAAAA4KUam5+i3m94UsUPoVoYwlA6MIShfGAIQ/nAEIbyOcBQSeNww9NZGOXBhuq8+w1fxugfDG1gmB0YBoFhdmAYBIbZgWEQGGYHhkFgmB0YBoFhdmAYBIbZyWB4qVI6mgyv4WUeH7u007lL7vFeWA3n8rUFrZqWK5KchnWvPapOTGFkNDQPOJrhk45Hw2d4Ns+oVPlRz2NhMxyawkTtv2OWAJvhSBwzfjBO2+g/5TLs7BDeSF4eDP0Y+yiX4UydFKtT4pRxa3SKTcVchtQgLYrobhq0Kj7+XIb0aX+fZtipHfH/ScPlZZG5Jq9hk2RYP96lTnFPcxnWpGF52d2eNrPGPc5lOJC5NDrl65Sv1fs16nEuw8v20sdCP+9uTh8NZVSuYVvTnKlBmjAdaqu/uH8Qm2FVWuNUJYSwOu3tLV9tcelNw5SF9yZjRaVixvpwbrZRTKnyuyKysRXOGn/QBqpK25QzptVm9598eyfqXDaPnah+GlNmwr/aGOcqYl3DvJtYzXU7jvU1bbVmVdExE+pP7Qjb6TiiOBFmOPuyD7XyC+djWYadGt2KxE5PzMpWluHtXc6KQZ/rNYK5RpThfWXnrGzp6iRcQ0ky7KbHK+iBup3rtQZD6wZJhq+9HDIsri89BBsUZPguIal0Y871K6ECRY6hXkFaimQeXQjVUHIMNwWkuVax5/q1xcC6Rozh0G+7vYmidaqzCaJ/whBjaEZJr608Y7QIHvBIMbR3/dfB55jr3/hrKCGGxMHN+vmi53rtSW+uEWLYUj1/dsY1169tetc1MgwHaw9HU3TN9Svec0huw4os6CZHcO7dcc/163O+XMNteC0JRfdk0Aby6BNfDcW9i1EquzedI4R36vAYLfy5htnwtnBRvaHo/SZxjN8Nz7UO5ltf97WnMgbqHCfhRbmHKa/hdXl2qxjzQQsaunMNr+FzUlD62W8bORD9TM4gshpe3xVg+Z7BonJlmN55mMhpWGkV4GughtacsbgvLnAa6hXga6B666I9OGsoRsPtMbCa7l2q6OVaAs6uMxpejXDdd+SPSTMP+vyGdri6+bAQui8u8BmaIbwxUdcXkg0dNRTjOf6BNiSOGirrXYxjcXQ+632ag6EPE7kMiU/h4dA1FJfhgUnTzZTRkCOEt8apYcpj+P1E6u4+j+H3E+kCdUmKxZAjkS4QrbMY8nwKC7qGYjFkSaQL9rqGw5AthORhIoMhUyJ9ksPwsDI+Brv97xtWY8mJNUwZYtixYu0qyjhd+yYwDALD7MAwCAyzA8MgMMwODIPAMDtHGxZ1JYvjDRvWajCC7SYRfhsBhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvJJM/wpEgyv9U+R8iNaAAAAAAAAAAAAAAAAAP4r/gEYCYE2Xwz6DQAAAABJRU5ErkJggg=='
  const [stateid, setstateid] = useState('')
  const [statecode, setStatecode] = useState('')
  const [mailcontent, setmailcontent] = useState([])
  const [Mailtoggle, setMailtoggle] = useState(false)
  const [ccmails, setccmails] = useState('')
  const [pono, setpono] = useState('')
  const [alltransportcollection, setalltransportcollection] = useState([])
  const [transpoid, settranspoid] = useState('')
  useEffect(() => {
    let cartproducts = []
    let productofcart = JSON.parse(localStorage.getItem('Carts'))
    //cartproducts.push()
setallcartproducts(productofcart)
  }, [])
  const Mailtoogle = () => {
    if (Mailtoggle) {
      setMailtoggle(false);
      setccmails('')
      //setInvoice(null);
    } else {
      setMailtoggle(true);
      setccmails('')
    }
  };
const roundofnet = Math.round(parseFloat(localStorage.getItem('Totalsumamounts')) + parseFloat(localStorage.getItem('Totaligstvalue')));
 //////////console.log(roundofnet,'round of')
 const roundofcal = parseFloat(roundofnet) -(parseFloat(localStorage.getItem('Totalsumamounts'))+parseFloat(localStorage.getItem('Totaligstvalue')))
//////////console.log(roundofcal, 'rounde of calculateion',localStorage.getItem('Totalsumamounts'),localStorage.getItem('Totaligstvalue'))

 const Createpurchaseorder = async() => {
     
    //////////console.log( localStorage.getItem('statecode') === '33')
  
   const create  = await axios.instance.post(`/Insertpurchaseorderhdr`, {
    OpType:"New",
 
    
    PO_Date:new Date(),
    Company_Id:localStorage.getItem('CompanyId'),
    Supplier_Id:suppliid,
    Remarks:"",
    Total_Amount:parseFloat(localStorage.getItem('Totalsumamounts')) ,
    Discount_Amount:0,
    VAT_Amount: localStorage.getItem('statecode') === '33'  ? parseFloat(localStorage.getItem('Totaligstvalue'))/2 :0,
    CST_Amount:0,
    Net_Amount:parseFloat(localStorage.getItem('Totalsumamounts')) + parseFloat(localStorage.getItem('Totaligstvalue')),
    Update_Received_Amount:0,
    Update_Debit_Amount:0,
    Created_by:localStorage.getItem('UserId'),
    Created_on:new Date(),
    Modified_by:localStorage.getItem('UserId'),
    Modified_on:new Date(),
    CurrencyId:1,
    Branch_Id:7,
    AmountinAED:1,
    Remarks2:"",
    Remarks3:"",
    PaymentTerms:"",
    Reamrks4:"",
    Delivery_date:deliverydate,
    ShipTo:1,
    POType:"Local",
    ExciseAmt:0,
    StateId:localStorage.getItem('stateid'),
    PlaceofSupply:"",
    StateCode:localStorage.getItem('statecode'),
    SGSTAmt:  localStorage.getItem('statecode') === '33'  ? parseFloat(localStorage.getItem('Totaligstvalue'))/2 :0,
    IGSTAmt:  localStorage.getItem('statecode') === '33'  ? 0: parseFloat(localStorage.getItem('Totaligstvalue')),
    RoundOff:0,
    RoundOffAmt:roundofcal,
    APPROVED:'N',
    ApprovedDate:new Date(),
    ApprovedBy:localStorage.getItem('UserId'),
    Transport_id:transpoid
     
    

   },{ headers: {'Authorization':tokent,
   'Content-Type': 'application/json',
   
   },method:"post"}).then((res) => {
  ////////console.log('header', res.data)
    for(const data of res.data) {
     localStorage.setItem('Purid', data.PO_Id)
    setpurchseid(data.PO_Id)
   setpono(data.PO_No)
    }
    }).then(async() => {
     // setdailoa1(true)
      if(suppliid.length !=0){

    
      const  details = localStorage.getItem('Carts')
      const Orderid =   localStorage.getItem('Purid')
      let product =  JSON.parse(details)
      for(const data of product){
        //////////console.log(data)
        const productcoll = Object.assign({
          PO_Id:localStorage.getItem('Purid'),
          Product_Details_Id:data.Product_Details_Id,
          UOM_Id:data.UOM_Id,
          Order_Quantity:data.Order_Quantity,
          Rate:data.Rate,
          CST_Percentage:0,  
          VAT_Percentage: localStorage.getItem('statecode') === '33' ? data.VAT_Percentage:0,
          Discount_Percentage:0,
          RateinAED:data.Rate,
          TaxId:data.TaxId,
          UOMtype:0,
          DiscAmt:0,
          ExciseId:0,
          ExcisePer:0,  
          OtherDesc:'',
          GSTPer:data.GSTPer,
          SGSTId: localStorage.getItem('statecode') === '33'  ? data.SGSTId :0,
          SGSTPer: localStorage.getItem('statecode') === '33'  ? data.SGSTPer :0,
          IGSTId:localStorage.getItem('statecode') === '33' ? 0: data.IGSTId,
          IGSTPer:localStorage.getItem('statecode') === '33' ? 0:data.IGSTPer,
          PriUOM_Id:data.UOM_Id,
          PriOrder_Quantity:data.Order_Quantity,
          PriRate:data.Rate,
          ConQty:data.Order_Quantity,
          Act_UOM:data.UOM_Id,
          Act_Rate:data.Rate,
          Act_Qty:data.Order_Quantity,
          Sec_UomId:data.UOM_Id
          
          
          },{PO_Id: parseInt(Orderid),OpType:'New'})
    const Dtl  =  await axios.instance.post(`/Insertpurchaseorderdtl`, productcoll
    
    ,{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
     
      },method:"post"}).then((res) => {
        ////////console.log( 'details', res.data)

        localStorage.removeItem('TotalQty');
        localStorage.removeItem('taxvalue');
        localStorage.removeItem('Totalsumamounts')
        localStorage.removeItem('Carts')
        localStorage.removeItem('Totaligstvalue')
   
localStorage.removeItem('purchasecart')
localStorage.removeItem('totalsalesrate')

localStorage.setItem('purchasecart',0)


    })

    setTimeout(() => {
      setdailoa1(false)
      setsupperror(false)
    }, 2000);
  
    setPurchasesavess(true)
setTimeout(() => {
  history.push('/Purchaseorder')
  setsupperror(false)
}, 3000);
  
    }
    SendMail()

  }else{
    if(suppliid.length === 0){
      setsupperror(true)
       }
       setTimeout(() => {
        setsupperror(false)
       }, 2000);
  }
  })
  }
useEffect(() => {
  
  Getalltransport()
  Getallsuppliervalue()
}, [])
const gettranid= (id) => {
  settranspoid(id)
        }
  const Getallsuppliervalue = async() => {
    const get= await axios.instance.get('/Getallsupplier',{ headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      
      const data  =res.data
      const options = data.map(b => ( {
      'label' : b.Customer_Name,
      'value' : b.Customer_Id
      }))

setallsupplierinfo(options)
//////////console.log(data)

    })
    }
    const Getalltransport = async() => {
      const get= await axios.instance.get(`/Getalltransemaster`,{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
        
        const data  =res.data
        const options = data.map(b => ( {
        'label' : b.Transport_Name,
        'value' : b.Transport_Id
        }))
  
  setalltransportcollection(options)
      })
      }

    const Getonesupplier = async(id) => {
      const get= await axios.instance.get(`/Getonesupplier/${id}`,{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
        
      
  
  setonsupplierinfo(res.data)
  for(const data of res.data){
setemailid(data.EmailId)
setphone(data.Phone)
setcountry(data.Country)
setaddress(data.Address1)
setcity(data.City)
setzipcode(data.Zip_Code)
localStorage.setItem('stateid', data.StateId)
localStorage.setItem('statecode',data.StateCode)
// setstateid(localStorage.getItem('stateid'))
// setStatecode(localStorage.getItem('statecode'))
//////////console.log(data)
  }
      })
      }
    const getbuyers =(id) => {
      setsuppliid(id)
      Getonesupplier(id)
    }
    const GetMailInfo  =  async(Content) => {
      setmailcontent(Content)
      Mailtoogle()
   
   
     }
     const SendMail  = async() => {
      ////////////console.log(mailcontent.Buyer)
    
        const mail =  await axios.instance.post(`/mail` , 
      {
    username :localStorage.getItem('EmailId'),
    tomail:emailid,
    sub:"Purchase Order",
    pono:1,
    host:localStorage.getItem('SMTPServer'),
    port:localStorage.getItem('smtpport'),
  // --Factorycontactperson :"test",
    password:localStorage.getItem('mailpassword'),
    Companyname:localStorage.getItem('companyName'),
    loginname:localStorage.getItem('UserName'),
     CcMail : localStorage.getItem('CCEmailId')
    
  },
      
      
     { headers: {'Authorization':tokent,
       'Content-Type': 'application/json'}}).then((res) => {
      if(res.status === 200) {
          toastr.success('Mail Sent Successfully', 'Purchase Order')
      }else {
        toastr.error('Something went wrong ', 'Purchase Order')
      }
       })
      Mailtoogle()
      PrintDownload()
    }   
//     const Getalltaxvalue = async(id) => {
//       const get= await axios.instance.get(`/Getalltaxpercentage/${}`,{ headers: {'Authorization':tokent,
//       'Content-Type': 'application/json',
      
//       }}).then((res) => {
        
      
  
//   setonsupplierinfo(res.data)
//   for(const data of res.data){
// setemailid(data.EmailId)
// setphone(data.Phone)
// setcountry(data.Country)
// setaddress(data.Address1)
// setcity(data.City)
// setzipcode(data.Zip_Code)
// localStorage.setItem('stateid', data.StateId)
// localStorage.setItem('statecode',data.StateCode)
//   }
//       })
//       }
const PrintDownload =async() => {
  // --const Arg = id.InvoiceId
// setdailoa1(true)
// //////////console.log('pritn',id)

const PrintInvoice = await axios.instance.get(`/Purchaseprint/${localStorage.getItem('Purid')}`).then(async() => {

})


}

const productredirect =(id) => {
  history.push(`/Purchase-order-detail/${id}`)
}
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Purchase Order" breadcrumbItem="Checkout" />

          <div className="checkout-tabs">
            <Row className="mb-3">
              <Col xl="8">
                <div className="custom-accordion">
                  <Card>
                    <Link onClick={toggle} className="text-dark" to="#">
                      <div className="p-4">
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0 me-3">
                            <i className="uil uil-receipt text-primary h2"></i>
                          </div>
                          <div className="flex-grow-1 overflow-hidden">
                            <h5 className="font-size-16 mb-1">Billing Info</h5>
                            <p className="text-muted text-truncate mb-0"></p>
                          </div>
                          <div className="flex-shrink-0">
                            <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                          </div>
                        </div>
                      </div>
                    </Link>
                    <Collapse isOpen={isOpen}>
                      <div className="p-4 border-top">
                        <Form>
                          <div>
                            <Row>
                              <Col lg={4}>
                                <div className="mb-3 mb-4">
                                  <Label
                                    htmlFor="billing-name"

                                    className="form-label"
                                  >
                                    Supplier Name
                                  </Label>
                                  <Select
                                options={allsupplierinfo}
                     classNamePrefix="select2-search-disable"
                     onChange={(value)=> getbuyers(value.value)}
                   />
                                </div>
                                {supperror ? <p  className="error">Please Select Supplier </p> :  null}

                              </Col>
                              <Col lg={4}>
                                <div className="mb-3 mb-4">
                                  <Label
                                    htmlFor="billing-email-address"

                                    className="form-label"
                                  >
                                    Email Address
                                  </Label>
                                  <Input
                                    type="email"
                                    className="form-control"
                                    id="billing-email-address"
                                    placeholder="Enter your email"
                                    value={emailid}
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div className="mb-3 mb-4">
                                  <Label
                                    htmlFor="billing-phone"

                                    className="form-label"
                                  >
                                    Phone
                                  </Label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="billing-phone"
                                    placeholder="Enter your Phone no."
                                    value={phone}
                                    disabled
                                  />
                                </div>
                              </Col>
                            </Row>
                            <div className="mb-4">
                              <Label
                                htmlFor="billing-address"
                                className="form-label"
                              >
                                Address
                              </Label>
                              <textarea
                                className="form-control"
                                id="billing-address"
                                rows="3"
                                value={address}
                                disabled
                                placeholder="Enter full address"
                              />
                            </div>
                            <Row>
                              <Col lg={4}>
                                <FormGroup className="mb-4 mb-lg-0">
                                  <Label className="form-label">
                                    Country
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                   
                                    value={country}
                                  />

                                </FormGroup>
                              </Col>
                              <Col lg={4}>
                                <div className="mb-4 mb-lg-0">
                                  <Label className="form-label" htmlFor="billing-city">City</Label>
                                  <Input type="text" disabled value={city} className="form-control" id="billing-city" placeholder="Enter City" />
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div className="mb-4 mb-lg-0">
                                  <Label className="form-label" htmlFor="zip-code">ZipCode</Label>
                                  <Input type="text" disabled value={zipcode} className="form-control" id="zip-code" placeholder="Enter Postal code" />
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div className="mb-4 mb-lg-0">
                                  <Label className="form-label" htmlFor="zip-code">Delivery Date</Label>
                                  <Input type="date"  value={moment (deliverydate).format('YYYY-MM-DD')} onChange={(e)=>setdeliverydate(e.target.value)} className="form-control" id="zip-code" placeholder="Enter Postal code" />
                                </div>
                              </Col>
                              <Col lg={4}>
                                  <div className="mb-3 mb-4">
                                    <Label
                                      htmlFor="billing-name"
  
                                      className="form-label"
                                    >
                                      Transport Name
                                    </Label>
                                    <Select
                                  options={alltransportcollection}
                       classNamePrefix="select2-search-disable"
                       onChange={(value)=> gettranid(value.value)}
                     />
                                  </div>
                                 
  
                                </Col>
                            </Row>
                          </div>
                        </Form>
                      </div>
                    </Collapse>
                  </Card>
                  {/* <Card>
                    <Link onClick={toggleShippinginfo} className="collapsed text-dark" to="#">
                      <div className="p-4">

                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0 me-3">
                            <i className="uil uil-truck text-primary h2"></i>
                          </div>
                          <div className="flex-grow-1 overflow-hidden">
                            <h5 className="font-size-16 mb-1">Shipping Info</h5>
                            <p className="text-muted text-truncate mb-0"></p>
                          </div>
                          <div className="flex-shrink-0">
                            <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                          </div>
                        </div>

                      </div>
                    </Link>
                    <Collapse isOpen={isOpenShippinginfo}>
                      <div className="p-4 border-top">
                        <h5 className="font-size-14 mb-3">Shipping Info</h5>
                        <Row>
                          <Col lg={4} sm={6}>
                            <Card className="border rounded active shipping-address">
                              <CardBody>
                                <Link to="#" className="float-end ml-1" title="Edit">
                                  <i className="uil uil-pen font-size-16"></i>
                                </Link>
                                <h5 className="font-size-14 mb-4">Address 1</h5>

                                <h5 className="font-size-14">James Morgan</h5>
                                <p className="mb-1">1557 Sundown Lane Smithville, TX 78957</p>
                                <p className="mb-0">Mo. 012-345-6789</p>
                              </CardBody>
                            </Card>

                          </Col>
                          <Col lg={4} sm={6}>
                            <Card className="card border rounded shipping-address">
                              <CardBody>
                                <Link to="#" className="float-end ml-1" title="Edit">
                                  <i className="uil uil-pen font-size-16"></i>
                                </Link>
                                <h5 className="font-size-14 mb-4">Address 2</h5>

                                <h5 className="font-size-14">James Morgan</h5>
                                <p className="mb-1">1557 Sundown Lane Smithville, TX 78957</p>
                                <p className="mb-0">Mo. 012-345-6789</p>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </Collapse>
                  </Card>
                  <Card>
                    <Link onClick={togglePaymentinfo} className="collapsed text-dark" to="#">
                      <div className="p-4">

                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0 me-3">
                            <i className="uil uil-bill text-primary h2"></i>
                          </div>
                          <div className="flex-grow-1 overflow-hidden">
                            <h5 className="font-size-16 mb-1">Payment Info</h5>
                            <p className="text-muted text-truncate mb-0"></p>
                          </div>
                          <div className="flex-shrink-0">
                            <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                          </div>
                        </div>

                      </div>
                    </Link>
                    <Collapse isOpen={isOpenPaymentinfo}>
                      <div className="p-4 border-top">
                        <div>
                          <h5 className="font-size-14 mb-3">Payment method :</h5>
                          <Row>
                            <Col lg={3} col={6}>
                              <div>
                                <label className="card-radio-label">
                                  <input type="radio" name="pay-method" id="pay-methodoption1" className="card-radio-input" />

                                  <span className="card-radio text-center text-truncate">
                                    <i className="uil uil-postcard d-block h2 mb-3"></i>
                                    Credit / Debit Card
                                  </span>
                                </label>
                              </div>
                            </Col>

                            <Col lg={3} col={6}>
                              <div>
                                <label className="card-radio-label">
                                  <input type="radio" name="pay-method" id="pay-methodoption2" className="card-radio-input" />

                                  <span className="card-radio text-center text-truncate">
                                    <i className="uil uil-paypal d-block h2 mb-3"></i>
                                    Paypal
                                  </span>
                                </label>
                              </div>
                            </Col>

                            <Col lg={3} col={6}>
                              <div>
                                <label className="card-radio-label">
                                  <input type="radio" name="pay-method" id="pay-methodoption3" className="card-radio-input" defaultChecked />

                                  <span className="card-radio text-center text-truncate">
                                    <i className="uil uil-money-bill d-block h2 mb-3"></i>
                                    <span>Cash on Delivery</span>
                                  </span>
                                </label>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Collapse>
                  </Card> */}
                </div>
                <Row>
                  <Col>
                    <Link to="/Purchaseorder" className="btn btn-link text-muted">
                      <i className="uil uil-arrow-left me-1"></i> Continue Shopping
                    </Link>
                  </Col>
                  <Col>
                    <div className="text-sm-end mt-2 mt-sm-0">
                      <Link to="#" className="btn btn-success" onClick={Createpurchaseorder}>
                        <i className="uil uil-shopping-cart-alt me-1"></i> Proceed </Link>
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col xl="4">

                <Card className="checkout-order-summary">
                  <CardBody>
                    <div className="p-3 bg-light mb-4">
                      <h5 className="font-size-16 mb-0">Order Summary <span className="float-end ml-2"></span></h5>
                    </div>

                    <div className="table-responsive">
                      <Table className="table-centered mb-0 table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th className="border-top-0" style={{ width: "110px" }} scope="col">Product</th>
                            <th className="border-top-0" scope="col">Product Description</th>
                         
                          </tr>
                        </thead>
                        {allcartproducts.map((data, index) => (
                        <tbody  key ={data.Product_Details_Id}>
                         
                            <tr key={data.Product_Details_Id}>
                              <th scope="row">
                              <img src={`${data.Imagepath}`} 
 style={{width:'50px', height:'50px'}}
  alt="" className="img-fluid mx-auto d-block"
  onError={({ currentTarget }) => {
    currentTarget.onerror = null; // prevents looping
    currentTarget.src=imageDefault;
  }}
   
  /> 
                              </th>
                              <td>
                                <h5 className="font-size-14 text-truncate">
                                  <Link
                                    to="#"
                                    className="text-dark"
                                    onClick={()=>productredirect(data.Product_Details_Id)}
                                  >
                                    {data.Product_Details_Description}{" "}
                                  </Link>
                                </h5>
                                <p className="text-muted mb-0">
                              
                                </p>
                              </td>
                              <td>
                             
                              </td>
                            </tr>
                      
                          <tr>
                            <td colSpan="2">
                              <h6 className="font-size-14 m-0">
                              Gross Amount:
                              </h6>
                            </td>
                            <td className="text-end">₹ {numeral(data.Order_Quantity * data.Rate).format('0,0.00') }</td>
                          </tr>
                      

                          <tr>
                            <td colSpan="2">
                              <h5 className="font-size-14 m-0">GST Amount:</h5>
                            </td>
                            <td>
                            <td className="text-end"> ₹ {numeral(((data.Rate * data.Order_Quantity) * data.GSTPer/100)).format('0,0.00')}</td>
                            </td>
                          </tr>

                          <tr className="bg-light">
                            <td colSpan="2">
                              <h5 className="font-size-14 m-0">Total:</h5>
                            </td>
                            <td className="text-end">
                            <span className="fw-bold">₹ {numeral(parseFloat((data.Order_Quantity * data.Rate))+parseFloat(((data.Rate * data.Order_Quantity) * data.GSTPer/100))).format('0,0.00') }</span>
                          </td>
                          </tr>
                        </tbody>
                          ))}
                      </Table>
                    </div>
                  </CardBody>
                </Card>
                
              </Col>
            
            </Row>
          </div>
        </Container>
      </div>
      {dailoa1 ? (
      <Backdrop  open={dailoa1} className={classes.backdrop} >
      <Spinner name="ball-spin-fade-loader"  color='#fafafa' />

     </Backdrop>
      ): null}
      {Purchasesavess ? (
                    <SweetAlert
                      title="Purchase Order Added Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setPurchasesavess(false);
                      }}
                    ></SweetAlert>
                  ) : null}
    </React.Fragment>
  );
};

export default EcommerceCheckout;
